export default "__VITE_ASSET__Djg1tiU8__"